import { memo } from 'react';
import PropTypes from 'prop-types';
import { PaginatedLoadingTable } from '@artprov/design-system';
import { columnasMatchingBancarioList } from '../columnasMatchingBancarioList';

/**
 * Tabla memoizada de Matching Bancario.
 * Solo re-renderiza si cambian las props relevantes (data, selected, isLoading, etc.).
 * Cuando el usuario tipea en la búsqueda pero los registros aún no cambiaron,
 * este componente se salta el renderizado completo, evitando que el navegador
 * procese ~1000 celdas en cada tecla.
 */
export const MatchingBancarioTable = memo(function MatchingBancarioTable({
    data,
    isLoading,
    onPageChange,
    headers,
    page,
    pageSize,
    setSelected,
    selected,
    emptyState,
    hasErrors,
    selectable = true,
    sortConfig,
    setSortConfig,
}) {
    return (
        <PaginatedLoadingTable
            selectable={selectable}
            columns={columnasMatchingBancarioList}
            data={data}
            sortable={true}
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
            isLoading={isLoading}
            showPagination={true}
            onPageChange={onPageChange}
            headers={headers}
            page={page}
            pageSize={pageSize}
            setSelected={setSelected}
            selected={selected}
            loadingIcon="progress_activity"
            loadingText="Solicitud en proceso"
            loadingIconVariant="primary"
            textVariant="subtitle1"
            textClassName="text-primary-10"
            emptyState={isLoading ? null : emptyState}
            flags={hasErrors}
            scrollArea={{ scrollY: false }}
        />
    );
});

MatchingBancarioTable.propTypes = {
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onPageChange: PropTypes.func.isRequired,
    headers: PropTypes.object.isRequired,
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    setSelected: PropTypes.func.isRequired,
    selected: PropTypes.array.isRequired,
    emptyState: PropTypes.object.isRequired,
    hasErrors: PropTypes.bool.isRequired,
    selectable: PropTypes.bool,
    sortConfig: PropTypes.shape({
        key: PropTypes.string,
        direction: PropTypes.string,
    }).isRequired,
    setSortConfig: PropTypes.func.isRequired,
};
